webpackJsonp([217291770958705],{

/***/ 255:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.pageQuery = undefined;
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactHelmet = __webpack_require__(10);
	
	var _reactHelmet2 = _interopRequireDefault(_reactHelmet);
	
	var _get = __webpack_require__(8);
	
	var _get2 = _interopRequireDefault(_get);
	
	var _gatsbyImage = __webpack_require__(6);
	
	var _gatsbyImage2 = _interopRequireDefault(_gatsbyImage);
	
	var _moment = __webpack_require__(13);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	var _postDetailModule = __webpack_require__(71);
	
	var _postDetailModule2 = _interopRequireDefault(_postDetailModule);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var EventTemplate = function (_React$Component) {
	  _inherits(EventTemplate, _React$Component);
	
	  function EventTemplate() {
	    _classCallCheck(this, EventTemplate);
	
	    return _possibleConstructorReturn(this, _React$Component.apply(this, arguments));
	  }
	
	  EventTemplate.prototype.render = function render() {
	    var post = (0, _get2.default)(this.props, 'data.contentfulEvent');
	    var siteData = (0, _get2.default)(this.props, 'data.site.siteMetadata');
	
	    // console.log()
	
	    var rawPd = (0, _get2.default)(this.props, 'data.contentfulEvent.date');
	    var eventDate = (0, _moment2.default)(rawPd, 'DD MMMM YYYY').format('YYYY-MM-DD');
	    // const dEventDate = moment(rawPd, 'DD MMMM YYYY').format('DD MMMM YYYY')
	    var rawEd = (0, _get2.default)(this.props, 'data.contentfulEvent.endDate');
	    var endDate = (0, _moment2.default)(rawEd, 'DD MMMM YYYY').format('YYYY-MM-DD');
	    // const dEndDate = moment(rawEd, 'DD MMMM YYYY').format('DD MMMM YYYY')
	
	
	    return _react2.default.createElement(
	      'div',
	      { style: { background: '#fff' }, className: 'page-content' },
	      _react2.default.createElement(
	        _reactHelmet2.default,
	        { title: post.title + ' | ' + siteData.title },
	        _react2.default.createElement('link', { rel: 'canonical', href: siteData.siteUrl + '/event/' + post.slug }),
	        _react2.default.createElement('meta', { name: 'description', content: '' + post.excerpt }),
	        _react2.default.createElement('meta', { name: 'title', content: post.title + ' | ' + siteData.title }),
	        _react2.default.createElement('meta', { property: 'og:title', content: post.title + ' | ' + siteData.title }),
	        _react2.default.createElement('meta', { property: 'og:site_name', content: 'YOUCAT Indonesia' }),
	        _react2.default.createElement('meta', { property: 'og:url', content: siteData.siteUrl + '/event/' + post.slug }),
	        _react2.default.createElement('meta', { property: 'og:description', content: '' + post.excerpt }),
	        _react2.default.createElement('meta', { property: 'og:image', content: '' + post.thumbnail.sizes.src }),
	        _react2.default.createElement('meta', { property: 'og:locale', content: 'id_ID' }),
	        _react2.default.createElement('meta', { property: 'og:type', content: 'article' }),
	        _react2.default.createElement('meta', { property: 'article:published_time', content: '' + eventDate }),
	        _react2.default.createElement('meta', { property: 'article:author', content: 'Youcat Indonesia' }),
	        _react2.default.createElement(
	          'script',
	          { type: 'application/ld+json' },
	          '"@context": "https://www.schema.org",\n              "@type": "Event",\n              "name": ' + post.title + ',\n              "url": ' + siteData.siteUrl + '/event/' + siteData.slug + ',\n              "description": ' + post.excerpt + ',\n              "startDate": ' + eventDate + ',\n              "endDate": ' + endDate + ',\n              "location": ' + post.venue
	        )
	      ),
	      _react2.default.createElement(
	        'div',
	        { className: 'grid-x grid-padding-x grid-padding-y' },
	        _react2.default.createElement(
	          'div',
	          { className: 'program-image post-image cell medium-shrink ' + _postDetailModule2.default.postThumbWrapper },
	          _react2.default.createElement(_gatsbyImage2.default, { className: _postDetailModule2.default.postThumb, alt: post.title, sizes: post.thumbnail.sizes })
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: 'cell medium-auto' },
	          _react2.default.createElement(
	            'h1',
	            { className: _postDetailModule2.default.postTitle },
	            post.title
	          ),
	          _react2.default.createElement('div', { className: _postDetailModule2.default.postContent,
	            dangerouslySetInnerHTML: {
	              __html: post.body.childMarkdownRemark.html
	            }
	          }),
	          _react2.default.createElement(
	            'div',
	            { className: 'event-info' },
	            _react2.default.createElement(
	              'table',
	              { className: _postDetailModule2.default.table },
	              _react2.default.createElement(
	                'tbody',
	                null,
	                _react2.default.createElement(
	                  'tr',
	                  null,
	                  _react2.default.createElement(
	                    'th',
	                    null,
	                    'Tanggal'
	                  ),
	                  _react2.default.createElement(
	                    'td',
	                    null,
	                    eventDate ? '' + rawPd : '',
	                    endDate ? ' - ' + rawEd : ''
	                  )
	                ),
	                post.venue ? _react2.default.createElement(
	                  'tr',
	                  null,
	                  _react2.default.createElement(
	                    'th',
	                    null,
	                    'Lokasi'
	                  ),
	                  _react2.default.createElement(
	                    'td',
	                    null,
	                    '' + post.venue
	                  )
	                ) : '',
	                post.registerUrl ? _react2.default.createElement(
	                  'tr',
	                  null,
	                  _react2.default.createElement(
	                    'th',
	                    null,
	                    'Registrasi'
	                  ),
	                  _react2.default.createElement(
	                    'td',
	                    null,
	                    _react2.default.createElement(
	                      'a',
	                      { href: '' + post.registerUrl },
	                      'Ketuk Disini'
	                    )
	                  )
	                ) : ''
	              )
	            )
	          )
	        )
	      )
	    );
	  };
	
	  return EventTemplate;
	}(_react2.default.Component);
	
	exports.default = EventTemplate;
	var pageQuery = exports.pageQuery = '** extracted graphql fragment **';

/***/ })

});


// WEBPACK FOOTER //
// component---src-templates-event-post-js-0ecb01f9be9a7223e98a.js